<!--
// app/pages/[region]/qualifiers/americas.vue
-->
<script setup lang="ts">
import type { Team } from "~~/src/team/domain/models/Team";
import type { MatchCenterData } from "~~/src/match/domain/models/Match";
import { useSeasons } from "~/composables/season/seasons";
import { useTeams } from "~/composables/teams";
import MatchTurns from "~/components/pages/region-matches/MatchTurns.vue";
import HeaderBannerTitle from "~/components/Shared/HeaderBannerTitle.vue";
import { useNuxtApp } from "#imports";

const { $t, $getLocale } = useNuxtApp();

definePageMeta({
  middleware: [
    "not-found-americas",
    "not-found-world-cup",
    "not-found-spain",
    "not-found-italy",
    "not-found-nations",
    "not-found-queens",
    "not-found-brazil",
    "not-found-france",
    "not-found-germany",
    "not-found-mena",
  ],
});

const locale = $getLocale();
const { getSeasonTeams, useFetchParamsSeasonMatchCenterData } = useSeasons();
const { teamArrToObjById } = useTeams();

const turns = ref<Record<string, MatchCenterData[]>>();
const teams = ref<Record<number, Team>>();
const matchComponentKey = ref<number>(0);
const loadingSeasonData = ref<boolean>(false);

const kokSeasonQualifiersAmericas = 24;

const getSeasonData = async (): Promise<void> => {
  try {
    loadingSeasonData.value = true;

    const path = useFetchParamsSeasonMatchCenterData(kokSeasonQualifiersAmericas, locale).path;
    const opts = useFetchParamsSeasonMatchCenterData(kokSeasonQualifiersAmericas, locale).opts;
    const { data, error } = await useFetch(path, opts);

    if (error.value) {
      console.error(error.value);
    }

    turns.value = kokSeasonQualifiersAmericas ? data.value : undefined;

    const _teams = await getSeasonTeams(kokSeasonQualifiersAmericas);
    teams.value = await teamArrToObjById(_teams);
  } finally {
    loadingSeasonData.value = false;
    matchComponentKey.value++;
  }
};

await getSeasonData();

useSeoMeta({
  title: "King of Kings - Americas",
  ogTitle: "King of Kings - Americas",
  description: $t("meta.description.kok.pages", "Americas"),
  ogDescription: $t("meta.description.kok.pages", "Americas"),
});
</script>

<template>
  <header-banner-title :title="$t('matches.banner.title')"></header-banner-title>
  <section class="px-4 py-6">
    <div class="kql-w-container">
      <match-turns
        v-if="turns && teams"
        :group-turns="turns"
        :teams="teams"
        :key="matchComponentKey"
        :loading="loadingSeasonData"
        kok-qualifiers
        :season-id="kokSeasonQualifiersAmericas"
        time-zone="America/Mexico_City"
        region-param-prop="americas"
      />
    </div>
  </section>
</template>

<style scoped></style>
